// extracted by mini-css-extract-plugin
export default {"cardRoot":"styles_cardRoot__B24VF","cardFooter":"styles_cardFooter__WDxfi","chartContainer":"styles_chartContainer__7RCy0"};